import type { PulseIncident } from '@aithora/shared';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Who acknowledged a Pulse incident, as words. The server sends acknowledgedByName; a raw user
 * id (an older server) is never shown, and the viewer's own ack reads "you".
 */
export function ackerName(i: Pick<PulseIncident, 'acknowledgedBy' | 'acknowledgedByName'>, meId?: string | null): string {
  if (meId && i.acknowledgedBy === meId) return 'you';
  if (i.acknowledgedByName) return i.acknowledgedByName;
  if (!i.acknowledgedBy) return 'someone';
  if (i.acknowledgedBy === 'admin-token') return 'Aithora (admin token)';
  return UUID.test(i.acknowledgedBy) ? 'a team member' : i.acknowledgedBy;
}
